var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"block m-auto w-1/3 mb-4",attrs:{"src":require("../assets/DAILY-FRED-LOGO-JOSEPHINE_SANS_a9c4bb34-58aa-408c-b57e-75cc1749408c.png")}}),_c('Survey')],1)}
var staticRenderFns = []

export { render, staticRenderFns }